module.exports = __webpack_public_path__ + "assets/media/bolts.bfe807b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/MobileConfirmationStep/bolts.svg
// module id = 2594
// module chunks = 0